export const StarIconLeftFrame = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 19 19" fill="none">
			<path
				d="M11.1504 7.60254L11.291 8.03516H17.0869L12.7656 11.1748L12.3984 11.4414L12.5381 11.873L14.1885 16.9541L9.86719 13.8145L9.5 13.5469L9.13281 13.8145L4.81055 16.9541L6.46191 11.873L6.60156 11.4414L6.23438 11.1748L1.91309 8.03516H7.70898L7.84961 7.60254L9.5 2.52344L11.1504 7.60254Z"
				stroke="black"
				strokeWidth="1.25"
			/>
		</svg>
	);
};
